import React from "react";

function BS4_Navbar() {
  return (
    <div>
      <h1>BS4_Navbar Component</h1>
      <p>This is the BS4_Navbar tutorial page content.</p>
    </div>
  );
}

export default BS4_Navbar;
